import { sidoList } from '@/data/constances'
import * as eventUtil from '@/utils/eventUtil'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export const signinJoinInfoNetworkingWriteUsrMinix = {
  data() {
    return {
      sidoList: sidoList,
      eventUtil: eventUtil,
      selectedSido: {},
      //가데이터
      textarea: {
        companyIntroduce: '',
        idealTalent: '',
        productName: '',
        productBriefing: '',
      },
      sigunguList: [],
    }
  },
  computed: {
    ...mapGetters('join', ['getType', 'getSignupForm']),
  },
  methods: {
    ...mapMutations('join', ['setCurrentTab', 'setCompletedInfo']),
    ...mapActions('auth', ['isAlreadyExistUsername', 'signup']),
    ...mapActions('sms', ['requestVerifyNumber', 'confirmVerifyNumber']),
    ...mapActions('address', ['requestAddressList', 'requestAddressDetailList']),
    getAddressDetailList(admCode) {
      this.sigunguList = []

      this.requestAddressDetailList(admCode)
        .then((response) => {
          let addressList = response.data

          this.sigunguList.push({ value: '', text: '선택' })
          this.selectedSigungu = ''
          for (let i = 0; i < addressList.length; i++) {
            let value = addressList[i].admCode
            let text = addressList[i].lowestAdmCodeNm
            let addressMap = { value: value, text: text }

            this.sigunguList.push(addressMap)

            if (text == this.signupInfo.addressDetail) {
              this.selectedSigungu = value
            }
          }
        })
        .catch(() => {
          this.$alert('알림', '시군구 주소를 가져올 수 없습니다.')
        })
    },
  },
}
